import React from "react";
import classNames from "classnames";

const InputFieldAddon: React.FC<InputFieldAddonProps> = ({
  iconClass,
  onClick,
  ...props
}) => {
  return (
    <button
      onClick={onClick}
      className={classNames(
        "input-addon--icon input-addon__wrapper",
        iconClass,
      )}
      {...props}
    />
  );
};

export interface InputFieldAddonProps
  extends Omit<
    React.DetailedHTMLProps<
      React.ButtonHTMLAttributes<HTMLButtonElement>,
      HTMLButtonElement
    >,
    "onClick"
  > {
  iconClass: string;
  onClick: (event: React.SyntheticEvent) => void;
}

export default InputFieldAddon;
